const UNITS = {
  en: {
    g: 'g',
    kg: 'kg',
    l: 'l',
    m: 'm',
    ml: 'ml',
    unit: 'pcs',
    cm: 'cm',
    package: 'pkg',
    portion: 'portion',
    per: 'per',
  },
  uk: {
    g: 'г',
    kg: 'кг',
    l: 'л',
    m: 'м',
    ml: 'мл',
    unit: 'шт',
    cm: 'см',
    package: 'уп',
    portion: 'порцію',
    per: 'за',
  },
};

const DOCUMENT_DIALOG = {
  en: {
    doc_receipt: 'Goods receipt',
    doc_transfer: 'Transfer between warehouses',
    doc_replacement: 'Product replacement',
    doc_write_off: 'Write-off',
    doc_supplier_return: 'Return to supplier',
    doc_inventory: 'Inventory',
    dated: 'dated',
    SKU: 'SKU',
    Packages: 'Packages',
    Quantity: 'Quantity',
    Transferred: 'Transferred',
    Amount: 'Amount',
    Supplier: 'Supplier',
    'Cash register': 'Cash register',
    'List price sum': 'List price sum',
    'Supplier discount': 'Supplier discount',
    'Transport costs': 'Transport costs',
    Payable: 'Payable',
    Paid: 'Paid',
  },
  uk: {
    doc_receipt: 'Прихід товарів',
    doc_transfer: 'Переміщення між складами',
    doc_replacement: 'Заміна товару',
    doc_write_off: 'Списання товарів',
    doc_supplier_return: 'Повернення постачальнику',
    doc_inventory: 'Інвентаризація',
    dated: 'від',
    SKU: 'Артикул',
    Packages: 'Упаковки',
    Quantity: 'Кількість',
    Transferred: 'Переміщено',
    Amount: 'Сума',
    Supplier: 'Постачальник',
    'Cash register': 'Каса',
    'List price sum': 'Сума по прайсу',
    'Supplier discount': 'Знижка від постачальника',
    'Transport costs': 'Транспортні витрати',
    Payable: 'До сплати',
    Paid: 'Сплачено',
  },
};

export const ProductStockBalancesReport = {
  en: {
    ...UNITS.en,
    'Stock balances': 'Stock balances',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    Warehouse: 'Warehouse',
    Type: 'Type',
    All: 'All',
    'Goods purchase': 'Goods purchase',
    Consignment: 'Consignment',
    'Expand all': 'Expand all',
    'Collapse all': 'Collapse all',
    'Print report': 'Print report',
    Product: 'Product',
    SKU: 'SKU',
    Packages: 'Packages',
    Quantity: 'Quantity',
    Amount: 'Amount',
    'Per unit': 'Per unit',
    'Sale price per package': 'Sale price per package',
    'Amount at sale price': 'Amount at sale price',
    'Archived products': 'Archived products',
    'No stock to report': 'No stock to report',
    'Prototype data: there is no product card, so a product name opens its movement report':
      'Prototype data: there is no product card, so a product name opens its movement report',
  },
  uk: {
    ...UNITS.uk,
    'Stock balances': 'Залишки товарів',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    Warehouse: 'Склад',
    Type: 'Тип',
    All: 'Все',
    'Goods purchase': 'Закупівля товарів',
    Consignment: 'Під реалізацію',
    'Expand all': 'Розгорнути все',
    'Collapse all': 'Згорнути все',
    'Print report': 'Роздрукувати звіт',
    Product: 'Товар',
    SKU: 'Артикул',
    Packages: 'Упаковки',
    Quantity: 'Кількість',
    Amount: 'На суму',
    'Per unit': 'За одиницю',
    'Sale price per package': 'Сума продажу за одиницю',
    'Amount at sale price': 'Сума за ціною продажу',
    'Archived products': 'Товари архів',
    'No stock to report': 'Немає залишків для звіту',
    'Prototype data: there is no product card, so a product name opens its movement report':
      'Дані прототипу: картки товару немає, тому назва товару відкриває звіт «Рух по товару»',
  },
};

export const ProductSalesReport = {
  en: {
    ...UNITS.en,
    'Product sales': 'Product sales',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'No sales in the period': 'No sales in the period',
    'Prototype data: clients are names without cards, and a product name opens its movement report':
      'Prototype data: clients are names without cards, and a product name opens its movement report',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    'Business direction': 'Business direction',
    Warehouse: 'Warehouse',
    portion_qty: 'portions',
    'Expand all': 'Expand all',
    'Collapse all': 'Collapse all',
    SKU: 'SKU',
    Client: 'Client',
    Quantity: 'Quantity',
    Amount: 'Amount',
    'Cost price': 'Cost price',
    'Cost share': 'Cost share',
    Profit: 'Profit',
    Margin: 'Margin',
  },
  uk: {
    ...UNITS.uk,
    'Product sales': 'Продаж товарів',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'No sales in the period': 'Немає продажів за період',
    'Prototype data: clients are names without cards, and a product name opens its movement report':
      'Дані прототипу: клієнти — це імена без карток, а назва товару відкриває звіт «Рух по товару»',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    'Business direction': 'Напрямок діяльності',
    Warehouse: 'Склад товарів',
    portion_qty: 'порц.',
    'Expand all': 'Розгорнути все',
    'Collapse all': 'Згорнути все',
    SKU: 'Артикул',
    Client: 'Клієнт',
    Quantity: 'Кількість',
    Amount: 'Сума',
    'Cost price': 'Собівартість',
    'Cost share': '% собівартості',
    Profit: 'Прибуток',
    Margin: '% прибутку',
  },
};

export const ProductMovementReport = {
  en: {
    ...UNITS.en,
    ...DOCUMENT_DIALOG.en,
    'Movement of a product': 'Movement of a product',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'Select a product to build the report':
      'Select a product to build the report',
    'Prototype data: the buyers have no client cards, so Phone stays empty':
      'Prototype data: the buyers have no client cards, so Phone stays empty',
    'Client and phone are not printed: the buyers have no client cards':
      'Client and phone are not printed: the buyers have no client cards',
    Sale: 'Sale',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    Product: 'Product',
    Warehouse: 'Warehouse',
    'All warehouses': 'All warehouses',
    Time: 'Time',
    'Operation type': 'Operation type',
    Description: 'Description',
    Client: 'Client',
    Phone: 'Phone',
    Opening: 'Opening',
    Incoming: 'Incoming',
    Outgoing: 'Outgoing',
    Amount: 'Amount',
    'In stock': 'In stock',
    'Balance amount': 'Balance amount',
    'Period opening': 'Period opening',
    'Period closing': 'Period closing',
    'To warehouse': 'To warehouse',
    'From warehouse': 'From warehouse',
    'Print report': 'Print report',
    doc_receipt: 'Goods receipt',
    doc_transfer: 'Transfer between warehouses',
    doc_replacement: 'Product replacement',
    doc_write_off: 'Write-off',
    doc_supplier_return: 'Return to supplier',
    doc_inventory: 'Inventory',
  },
  uk: {
    ...UNITS.uk,
    ...DOCUMENT_DIALOG.uk,
    'Movement of a product': 'Рух по товару',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'Select a product to build the report':
      'Оберіть товар, щоб побудувати звіт',
    'Prototype data: the buyers have no client cards, so Phone stays empty':
      'Дані прототипу: покупці не мають карток клієнтів, тому колонка «Телефон» лишається порожньою',
    'Client and phone are not printed: the buyers have no client cards':
      'Колонки «Клієнт» і «Телефон» не друкуються: покупці не мають карток клієнтів',
    Sale: 'Продаж',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    Product: 'Товар',
    Warehouse: 'Склад',
    'All warehouses': 'Усі склади',
    Time: 'Час',
    'Operation type': 'Тип операції',
    Description: 'Опис',
    Client: 'Клієнт',
    Phone: 'Телефон',
    Opening: 'Початок',
    Incoming: 'Прихід',
    Outgoing: 'Витрата',
    Amount: 'На суму',
    'In stock': 'В залишках',
    'Balance amount': 'Сума залишків',
    'Period opening': 'На початок періоду',
    'Period closing': 'На кінець періоду',
    'To warehouse': 'На склад',
    'From warehouse': 'Зі складу',
    'Print report': 'Роздрукувати звіт',
    doc_receipt: 'Прихід товарів',
    doc_transfer: 'Переміщення між складами',
    doc_replacement: 'Заміна товару',
    doc_write_off: 'Списання товарів',
    doc_supplier_return: 'Повернення постачальнику',
    doc_inventory: 'Інвентаризація',
  },
};

export const GoodsMovementReport = {
  en: {
    ...UNITS.en,
    'Goods movement': 'Goods movement',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'No goods movement in the period': 'No goods movement in the period',
    'The prototype records no revaluations: Revaluation stays empty':
      'The prototype records no revaluations: Revaluation stays empty',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    'By product amounts': 'By product amounts',
    'By product quantities': 'By product quantities',
    Warehouse: 'Warehouse',
    'All warehouses': 'All warehouses',
    'Expand all': 'Expand all',
    'Collapse all': 'Collapse all',
    'Print report': 'Print report',
    Product: 'Product',
    SKU: 'SKU',
    'Period opening': 'Period opening',
    'Period closing': 'Period closing',
    Incoming: 'Incoming',
    Consumption: 'Consumption',
    Transfer: 'Transfer',
    'Write-off': 'Write-off',
    'Return to supplier': 'Return to supplier',
    Inventory: 'Inventory',
    Revaluation: 'Revaluation',
    'Archived products': 'Archived products',
    Period: 'Period',
  },
  uk: {
    ...UNITS.uk,
    'Goods movement': 'Рух товарів',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'No goods movement in the period': 'Немає руху товарів за період',
    'The prototype records no revaluations: Revaluation stays empty':
      'У прототипі немає переоцінок: колонка «Переоцінка товарних запасів» лишається порожньою',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    'By product amounts': 'По сумам товарів',
    'By product quantities': 'По кількості товарів',
    Warehouse: 'Склад',
    'All warehouses': 'Усі склади',
    'Expand all': 'Розгорнути все',
    'Collapse all': 'Згорнути все',
    'Print report': 'Роздрукувати звіт',
    Product: 'Товар',
    SKU: 'Артикул',
    'Period opening': 'На початок періоду',
    'Period closing': 'На кінець періоду',
    Incoming: 'Прихід',
    Consumption: 'Витрата',
    Transfer: 'Переміщення',
    'Write-off': 'Списання',
    'Return to supplier': 'Повернення',
    Inventory: 'Інвентаризація',
    Revaluation: 'Переоцінка товарних запасів',
    'Archived products': 'Товари архів',
    Period: 'Період',
  },
};

export const WarehouseTransfersReport = {
  en: {
    ...UNITS.en,
    ...DOCUMENT_DIALOG.en,
    'Transfers between warehouses': 'Transfers between warehouses',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'No transfers in the period': 'No transfers in the period',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    'Waybill number': 'Waybill number',
    'From warehouse': 'From warehouse',
    'To warehouse': 'To warehouse',
    Note: 'Note',
    Products: 'Products',
    Details: 'Details',
    'Transfer from': 'Transfer from',
    to: 'to',
    dated: 'dated',
    Moved: 'Moved',
    SKU: 'SKU',
    'Collapse all': 'Collapse all',
    'Expand all': 'Expand all',
    'Print report': 'Print report',
  },
  uk: {
    ...UNITS.uk,
    ...DOCUMENT_DIALOG.uk,
    'Transfers between warehouses': 'Переміщення між складами',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'No transfers in the period': 'Немає переміщень за період',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    'Waybill number': 'Номер накладної',
    'From warehouse': 'Зі складу',
    'To warehouse': 'На склад',
    Note: 'Примітки',
    Products: 'Товари',
    Details: 'Детальніше',
    'Transfer from': 'Переміщення з',
    to: 'на',
    dated: 'від',
    Moved: 'Переміщено',
    SKU: 'Артикул',
    'Collapse all': 'Згорнути все',
    'Expand all': 'Розгорнути все',
    'Print report': 'Роздрукувати звіт',
  },
};

export const StockCountHistoryReport = {
  en: {
    ...UNITS.en,
    'Stock-count history': 'Stock-count history',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'No stock counts in the period': 'No stock counts in the period',
    'Prototype data: the documents have no author, so Administrator stays empty':
      'Prototype data: the documents have no author, so Administrator stays empty',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    'Previous inventory': 'Previous inventory',
    'Inventory date': 'Inventory date',
    Warehouse: 'Warehouse',
    Administrator: 'Administrator',
    Note: 'Note',
    Details: 'Details',
    no: 'no',
    Inventory: 'Inventory',
    for: 'for',
    Display: 'Display',
    'Show all': 'Show all',
    'Show shortages only': 'Show shortages only',
    'Show surpluses only': 'Show surpluses only',
    'Enter the name or SKU of the product':
      'Enter the name or SKU of the product',
    SKU: 'SKU',
    Product: 'Product',
    'Period opening': 'Period opening',
    Receipts: 'Receipts',
    Transfers: 'Transfers',
    'Write-offs': 'Write-offs',
    'Supplier returns': 'Supplier returns',
    'Expense (plan)': 'Expense (plan)',
    'Actual (packages)': 'Actual (packages)',
    'Actual (units)': 'Actual (units)',
    'Stock value': 'Stock value',
    Discrepancy: 'Discrepancy',
    'Print report': 'Print report',
  },
  uk: {
    ...UNITS.uk,
    'Stock-count history': 'Історія звірок',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'No stock counts in the period': 'Немає інвентаризацій за період',
    'Prototype data: the documents have no author, so Administrator stays empty':
      'Дані прототипу: документи не мають автора, тому колонка «Адміністратор» лишається порожньою',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    'Previous inventory': 'Попередня інвентаризація',
    'Inventory date': 'Дата інвентаризації',
    Warehouse: 'Склад',
    Administrator: 'Адміністратор',
    Note: 'Примітки',
    Details: 'Детальніше',
    no: 'ні',
    Inventory: 'Інвентаризація',
    for: 'за',
    Display: 'Відображення',
    'Show all': 'Показувати всі',
    'Show shortages only': 'Показувати лише недостачу',
    'Show surpluses only': 'Показувати лише надлишки',
    'Enter the name or SKU of the product': 'Введіть назву або артикул товару',
    SKU: 'Артикул',
    Product: 'Товар',
    'Period opening': 'На початок періоду',
    Receipts: 'Прихід',
    Transfers: 'Переміщення',
    'Write-offs': 'Списання',
    'Supplier returns': 'Повернення постачальнику',
    'Expense (plan)': 'Витрата (план)',
    'Actual (packages)': 'На кінець періоду (упаковки)',
    'Actual (units)': 'На кінець періоду (факт)',
    'Stock value': 'Сума залишків',
    Discrepancy: 'Розбіжність',
    'Print report': 'Роздрукувати звіт',
  },
};

export const SupplyPaymentHistoryReport = {
  en: {
    ...UNITS.en,
    'Supply and payment history': 'Supply and payment history',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'No supplies in the period': 'No supplies in the period',
    'Prototype data: a payment is recorded on the receipt, so it always falls in the same period as the supply; consignment receipts are excluded — they move goods, not money':
      'Prototype data: a payment is recorded on the receipt, so it always falls in the same period as the supply; consignment receipts are excluded — they move goods, not money',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    Supplier: 'Supplier',
    Payment: 'Payment',
    Supply: 'Supply',
    'Expand all': 'Expand all',
    'Collapse all': 'Collapse all',
    'Print report': 'Print report',
  },
  uk: {
    ...UNITS.uk,
    'Supply and payment history': 'Історія поставок і оплат',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'No supplies in the period': 'Немає поставок за період',
    'Prototype data: a payment is recorded on the receipt, so it always falls in the same period as the supply; consignment receipts are excluded — they move goods, not money':
      'Дані прототипу: оплата фіксується в накладній приходу, тому завжди потрапляє в той самий період, що й поставка; прихід під реалізацію не враховується — він рухає товар, а не гроші',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    Supplier: 'Постачальник',
    Payment: 'Оплата',
    Supply: 'Прихід',
    'Expand all': 'Розгорнути все',
    'Collapse all': 'Згорнути все',
    'Print report': 'Роздрукувати звіт',
  },
};

export const SupplierSettlementsReport = {
  en: {
    ...UNITS.en,
    ...DOCUMENT_DIALOG.en,
    'Settlements with a supplier': 'Settlements with a supplier',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'The company has no locations, so the prototype has nothing to seed warehouses on',
    'Select a supplier to build the report':
      'Select a supplier to build the report',
    'Prototype data: payments are recorded on receipts, so the feed has no standalone payment rows; a consignment receipt shows its amount but does not move the debt until the goods are sold':
      'Prototype data: payments are recorded on receipts, so the feed has no standalone payment rows; a consignment receipt shows its amount but does not move the debt until the goods are sold',
    Day: 'Day',
    Month: 'Month',
    Year: 'Year',
    'Custom period': 'Custom period',
    Supplier: 'Supplier',
    Type: 'Type',
    Client: 'Client',
    'List price sum': 'List price sum',
    'Consignment quantity': 'Consignment quantity',
    'Supplier discount': 'Supplier discount',
    'Transport costs': 'Transport costs',
    Sum: 'Sum',
    Payout: 'Payout',
    'Debt to supplier': 'Debt to supplier',
    'Period opening': 'Period opening',
    'Period closing': 'Period closing',
    Receipt: 'Receipt',
    'Receipt (consignment)': 'Receipt (consignment)',
    Return: 'Return',
    'Receipt from': 'Receipt',
    'Consignment receipt from': 'Consignment receipt',
    'Print report': 'Print report',
  },
  uk: {
    ...UNITS.uk,
    ...DOCUMENT_DIALOG.uk,
    'Settlements with a supplier': 'Розрахунки з постачальником',
    'The company has no locations, so the prototype has nothing to seed warehouses on':
      'У компанії немає локацій, тому прототипу немає на чому створити склади',
    'Select a supplier to build the report':
      'Оберіть постачальника, щоб побудувати звіт',
    'Prototype data: payments are recorded on receipts, so the feed has no standalone payment rows; a consignment receipt shows its amount but does not move the debt until the goods are sold':
      'Дані прототипу: оплати фіксуються в накладних приходу, тому в стрічці немає окремих платежів; прихід під реалізацію показує суму, але не змінює заборгованість, поки товар не продано',
    Day: 'День',
    Month: 'Місяць',
    Year: 'Рік',
    'Custom period': 'Інший період',
    Supplier: 'Постачальник',
    Type: 'Тип',
    Client: 'Клієнт',
    'List price sum': 'Сума по прайсу',
    'Consignment quantity': 'Кількість товарів під реалізацію',
    'Supplier discount': 'Знижка від постачальника',
    'Transport costs': 'Транспортні витрати',
    Sum: 'Сума',
    Payout: 'Виплата',
    'Debt to supplier': 'Заборгованість постачальнику',
    'Period opening': 'На початок періоду',
    'Period closing': 'На кінець періоду',
    Receipt: 'Прихід',
    'Receipt (consignment)': 'Прихід (під реалізацію)',
    Return: 'Повернення',
    'Receipt from': 'Прихід',
    'Consignment receipt from': 'Прихід під реалізацію',
    'Print report': 'Роздрукувати звіт',
  },
};
